import { API_SERVER_URL } from '../shared/config/constants';
import { Observable } from 'rxjs';
import { getIdTokenFromLocalStorage } from "./DataService";

// Products are served exclusively via the backend REST API (PostgreSQL-backed).
// There is no Firestore fallback/onSnapshot path for Products in React —
// the backend owns any temporary Firestore compatibility on its own side.

export const getFailedSyncProductsFromServer = (
  userId: string,
  connector: string,
  limit: number,
  sortField: string,
  sortOrder: number,
  firstVisibleId?: string,
  lastVisibleId?: string,
  mode?: string,
  filters?: { key: string; value: any; }[]
): Observable<{
  products: any[];
  firstDocId: string;
  lastDocId: string;
  total?: number;
}> => {
  return new Observable(subscriber => {
    const processRequest = async () => {
      try {
        const idToken = await getIdTokenFromLocalStorage();
        const requestData = {
          userId,
          connector,
          limit,
          sortField,
          sortOrder,
          firstVisibleId,
          lastVisibleId,
          mode,
          filters: filters ? JSON.parse(JSON.stringify(filters)) : []
        };

        const response = await fetch(`${API_SERVER_URL}/products/failed`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${idToken}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response?.ok) {
          const error = await response?.json();
          console.error('Error in getFailedSyncProductsFromServer:', error);
          throw new Error('Failed to fetch failed products');
        }

        const data = await response?.json();
        const firstDocId = data?.firstDocId ? data?.firstDocId : null;
        const lastDocId = data?.lastDocId ? data?.lastDocId : null;
        subscriber.next({
          products: data?.products ?? [],
          firstDocId,
          lastDocId,
          total: data?.total
        });
        subscriber?.complete();

      } catch (error: any) {
        console.error('Error in getFailedSyncProductsFromServer:', error);
        subscriber?.error(error);
      }
    };

    processRequest();
  });
};

export const getSuccessSyncProductsFromServer = (
  userId: string,
  connector: string,
  limit: number,
  sortField: string,
  sortOrder: number,
  firstVisibleId?: string,
  lastVisibleId?: string,
  mode?: string,
  query?: { key: string; value: any; }[]
): Observable<{
  products: any[];
  firstDocId: string;
  lastDocId: string;
  total?: number;
}> => {
  return new Observable(subscriber => {
    const processRequest = async () => {
      try {
        const idToken = await getIdTokenFromLocalStorage();
        // Prepare the request data
        const requestData = {
          userId,
          connector,
          limit,
          sortField,
          sortOrder,
          firstVisibleId,
          lastVisibleId,
          mode,
          query: query ? JSON.parse(JSON.stringify(query)) : []
        };

        console.log("Fetching orders with params:", requestData);
        const response = await fetch(`${API_SERVER_URL}/products/success`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${idToken}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response?.ok) {
          const error = await response?.json();
          console.error('Error in getOrdersFromServer:', error);
          throw new Error('Failed to fetch orders');
        }

        const data = await response?.json();
        // Create document references for pagination
        const firstDocId = data?.firstDocId ? data?.firstDocId : null;
        const lastDocId = data?.lastDocId ? data?.lastDocId : null;
        subscriber.next({
          products: data?.products ?? [],
          firstDocId,
          lastDocId,
          total: data?.total
        });
        subscriber?.complete();

      } catch (error: any) {
        console.error('Error in getOrdersFromServer:', error);
        subscriber?.error(error);
      }
    };

    processRequest();
  });
};
